import React from 'react';
import { Modal, Button, Form } from 'antd';
export default class ImprimirModal extends React.Component {
    render() {
        return (
            <Modal
                title={"Imprimir Orden de Servicio"}
                visible={this.props.visible}
                onCancel={this.props.onClose}
                destroyOnClose={true}
                style={{ top: 30 }}
                width={900}
                footer={[
                    <Button
                        key="send"
                        type="primary"
                        onClick={this.props.onClose}
                    >
                        Ok
                    </Button>
                ]}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <embed
                                src={this.props.formValues.file}
                                style={{ width: '100%', height: 450 }}
                                type="application/pdf"
                            />
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}